import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import theme from '@ep/theme';
import { Gcms_SubMenus } from '@ep/types/gatsbyTypes';
import { HeaderMenuData } from '@ep/types/menuData';
import useQueryParam from '@ep/utils/useQueryParams';
import { WindowLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import Collapsible from './Collapsible';
import NavLink from './NavLink';
import SubNav from './SubNav';

interface NavProps extends React.HTMLAttributes<HTMLElement> {
  location?: WindowLocation;
  scrollingDown: boolean;
  subMenu?: Gcms_SubMenus[];
}

const Wrapper = styled.div`
  ${theme.mediaQueries.desktopMenuBreak} {
    display: none;
  }
`;

const NavbarContainer = styled(Container)`
  display: flex;
  max-width: 1430px;
`;

const NavBar = ({ scrollingDown, subMenu, ...rest }: NavProps) => {
  const [hoveredNavItemIndex, setHoveredNavItemIndex] = useState<number>();
  const data = useStaticQuery(graphql`
    query {
      gcms {
        menu(where: { position: "Header" }) {
          data
        }
      }
    }
  `);

  const menuData = data.gcms.menu.data as HeaderMenuData;
  const currentUrl =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const [menuType, setMenuType] = useQueryParam('menu', '');
  // const [activeNavUrl, setSctiveNavUrl] = useState<string>()

  // React.useEffect(() => {
  let currentUrlObj = { data: [{ link: currentUrl }] };
  let finalMenu: Gcms_SubMenus =
    subMenu && subMenu.length > 0 ? subMenu : currentUrlObj;
  if (subMenu && subMenu.length === 1) {
    finalMenu = subMenu[0];
  }
  if (subMenu && subMenu.length > 1) {
    if (!menuType) {
      finalMenu = subMenu[0];
    } else {
      subMenu.forEach((type) => {
        if (type.data[0].label === menuType) {
          finalMenu = type;
        }
      });
    }
  }

  let activeNavUrl = finalMenu?.data[0].link
    .split('-')
    .splice(0, 2)
    .join('-')
    .replaceAll('/', '');
  //   setSctiveNavUrl(url);
  // }, [currentUrl]);

  // const sendToGoogleAnalytics = (label: string) => {
  //   dataLayer.push({ event: label });
  // };

  return (
    <Wrapper>
      <Collapsible height="4rem" collapsed={scrollingDown} {...rest}>
        <NavbarContainer>
          {menuData.map((navItem: Gcms_SubMenus, index: number) => (
            <NavLink
              style={
                navItem?.link
                  .split('-')
                  .splice(0, 2)
                  .join('-')
                  .replaceAll('/', '') === activeNavUrl
                  ? { color: theme.colors.mediumBlue }
                  : { color: theme.colors.darkBlue }
              }
              key={navItem.label}
              onClick={() => setMenuType(navItem.label)}
              to={navItem.link ?? '/'}
              onMouseEnter={() => setHoveredNavItemIndex(index)}
              onMouseLeave={() => {
                if (hoveredNavItemIndex === index) {
                  setHoveredNavItemIndex(undefined);
                }
              }}
              // onClick={(event) =>
              //   sendToGoogleAnalytics(
              //     'Main menu item clicked - ' + navItem.label,
              //   )
              // }
            >
              {navItem.label}
            </NavLink>
          ))}
        </NavbarContainer>
      </Collapsible>
      <SubNav
        data={menuData}
        hoveredNavItemIndex={hoveredNavItemIndex}
        navCollapsed={scrollingDown}
      />
    </Wrapper>
  );
};

export default React.memo(NavBar);
